import { Gtp } from 'src/app/shared/gtp';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';

import { MatDialog } from '@angular/material/dialog';
import { MapaPopUpComponent } from 'src/app/shared/mapa/mapa-popup/mapa-popup.component';

@Component({
  selector: 'app-movilvelocidad',
  templateUrl: './movilvelocidad.component.html',
  styleUrls: ['./movilvelocidad.component.scss']
})

export class MovilvelocidadComponent implements OnInit {

  @Input() codequipo: any;
  @Input() descripcion: any;
  @Input() movildata: any;
  @Input() limiteVelocidad: number = 80;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  public dataSource: MatTableDataSource<any>;
  public pageIndex: number = 0;
  public pageSize: number = 5;

  public filter: any = {
    desde : null,
    hasta : null,
    velocidad: 10,
    buscar: '',
    orderby: 'fecha_hora',
    sortby: 'asc',
    pageIndex: 0,
    pageSize: 5
  };
  public loading: boolean = false;
  public tableCount;
  public emptyData:boolean = true;

  displayedColumns: string[] = [
    'fechahora',
    'direccion',
    'velocidad',
    'vermapa',
  ];

  // Propiedades para paginación y datos modernos
  public paginatedData: any[] = [];
  public currentPage: number = 0;

  constructor(
    private gtp: Gtp,
    public dialog: MatDialog
  ) {
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit() {
    // this.filter.desde = this.mdesde;
    // this.filter.hasta =this.mhasta;
    // this.filter.velocidad = this.mvelocidad;
    this.loadInformeInterno();
    this.updatePaginatedData();
  }

  loadInformeInterno(){
    this.loading = true;
    let info = [];
    this.movildata.forEach( (el,i) =>{
      let tmp = el;
      //let tmp = new ControlVelocidadGrafico(el);
      tmp.codequipo = this.codequipo;
      tmp.descripcion = this.descripcion;
      info.push(tmp);
    });
    this.loading = false;
    this.dataSource = new MatTableDataSource(info);
    this.dataSource.paginator = this.paginator;
    this.tableCount = this.dataSource.data.length;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    if(this.dataSource.data.length!=0){ this.emptyData = false; }

    // Actualizar datos paginados para el nuevo diseño
    this.updatePaginatedData();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  setSort(event?) {
    this.filter.orderby = event.active;
    this.filter.sortby = event.direction;
    //this.loadInformeInterno();
  }

  setPagination(event?) {
    this.filter.pageIndex = parseInt(event.pageIndex);
    this.filter.pageSize = parseInt(event.pageSize);
    //this.loadInformeInterno();
    return event;
  }

  getPageSizeOptions(): number[] {
    return [5, 10, 20, this.tableCount];
  }

  verMapa(latitud: any, longitud: any, rotacion: any) {
    this.dialog.open(MapaPopUpComponent, {
      data: {
        latitud: latitud,
        longitud: longitud,
        rotacion: parseFloat(rotacion) || 0
      }
    });
  }

  /**
   * Obtiene la velocidad máxima registrada
   */
  getMaxVelocidad(): number {
    if (!this.dataSource.data || this.dataSource.data.length === 0) {
      return 0;
    }
    const velocidades = this.dataSource.data.map(item => parseFloat(item.velocidad) || 0);
    return Math.max(...velocidades);
  }

  /**
   * Obtiene el promedio de velocidades
   */
  getPromedioVelocidad(): number {
    if (!this.dataSource.data || this.dataSource.data.length === 0) {
      return 0;
    }
    const velocidades = this.dataSource.data.map(item => parseFloat(item.velocidad) || 0);
    const promedio = velocidades.reduce((sum, vel) => sum + vel, 0) / velocidades.length;
    return Math.round(promedio);
  }

  /**
   * Obtiene el número de excesos de velocidad
   */
  getExcessCount(): number {
    if (!this.movildata || this.movildata.length === 0) {
      return 0;
    }
    return this.movildata.filter(item => {
      const velocidad = parseFloat(item.velocidad) || 0;
      return velocidad > this.limiteVelocidad;
    }).length;
  }

  /**
   * Obtiene la velocidad máxima (para el HTML - usa movildata)
   */
  getMaxSpeed(): string {
    if (!this.movildata || this.movildata.length === 0) return '0';
    const maxSpeed = Math.max(...this.movildata.map(item => parseFloat(item.velocidad) || 0));
    return maxSpeed.toString();
  }

  /**
   * Obtiene la velocidad promedio (para el HTML - usa movildata)
   */
  getAvgSpeed(): string {
    if (!this.movildata || this.movildata.length === 0) return '0';
    const avgSpeed = this.movildata.reduce((sum, item) => sum + (parseFloat(item.velocidad) || 0), 0) / this.movildata.length;
    return Math.round(avgSpeed).toString();
  }

  /**
   * Obtiene los datos paginados para mostrar
   */
  getPagedData(): any[] {
    if (!this.dataSource.data) {
      return [];
    }

    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    return this.dataSource.data.slice(startIndex, endIndex);
  }

  /**
   * Obtiene la clase CSS según la severidad del exceso de velocidad
   */
  getSeverityClass(item: any): string {
    const velocidad = parseFloat(item.velocidad) || 0;
    const limite = this.limiteVelocidad || 80;

    if (velocidad <= limite) {
      return 'normal';
    } else if (velocidad <= limite + 10) {
      return 'leve';
    } else if (velocidad <= limite + 20) {
      return 'moderado';
    } else {
      return 'severo';
    }
  }

  /**
   * Obtiene el texto de severidad
   */
  getSeverityText(item: any): string {
    const velocidad = parseFloat(item.velocidad) || 0;
    const limite = this.limiteVelocidad || 80;

    if (velocidad <= limite) {
      return 'Normal';
    } else if (velocidad <= limite + 10) {
      return 'Leve';
    } else if (velocidad <= limite + 20) {
      return 'Moderado';
    } else {
      return 'Severo';
    }
  }

  /**
   * Obtiene el icono según la severidad
   */
  getSeverityIcon(item: any): string {
    const velocidad = parseFloat(item.velocidad) || 0;
    const limite = this.limiteVelocidad || 80;

    if (velocidad <= limite) {
      return 'check_circle';
    } else if (velocidad <= limite + 10) {
      return 'info';
    } else if (velocidad <= limite + 20) {
      return 'warning';
    } else {
      return 'dangerous';
    }
  }

  /**
   * Maneja el cambio de página
   */
  onPageChange(event: any) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.updatePaginatedData();
  }

  /**
   * Actualiza los datos paginados
   */
  updatePaginatedData() {
    const startIndex = this.currentPage * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedData = this.movildata.slice(startIndex, endIndex);
  }

  /**
   * Formatea la fecha
   */
  formatDate(dateTime: string): string {
    return this.gtp.formatDate(dateTime);
  }

  /**
   * Formatea la hora
   */
  formatTime(dateTime: string): string {
    const date = new Date(dateTime);
    return date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  }

  /**
   * Obtiene la URL de Google Maps
   */
  getMapUrl(lat: string | number, lng: string | number): string {
    return `https://maps.google.com/?q=${lat},${lng}`;
  }

}
